import type { ReactNode } from 'react';
import { Text, Title } from '@repletoryreach/sdk-ui';

/**
 * The top of every sign-in card: an optional mark, the title and one muted
 * line saying who the screen is for.
 *
 * Each auth screen used to open with whatever heading its form felt like
 * rendering, so the four of them disagreed on size, alignment and whether
 * there was a heading at all. The layout cannot own this, because the copy
 * differs per route, so the shape is owned here and the words stay with the
 * page.
 */
export function AuthCardHeader(
  { title, subtitle, icon }: { title: ReactNode; subtitle?: ReactNode; icon?: ReactNode }
) {
  return (
    <header className="admin-auth__card-head">
      {icon && <span className="admin-auth__card-icon">{icon}</span>}
      <Title order={2}>{title}</Title>
      {subtitle && <Text fz="sm" c="var(--rr-color-text-muted)">{subtitle}</Text>}
    </header>
  );
}
